var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { forwardRef } from 'react';
import { extractSupportProps } from '@snack-uikit/utils';
import { APPEARANCE, HTML_TYPE, SIZE, TARGET } from '../../constants';
import { ButtonPrivate } from '../../helperComponents';
import { extractCommonButtonProps } from '../../utils';
import styles from './styles.module.css';
export const ButtonOutline = forwardRef((_a, ref) => {
    var { className, size = SIZE.S, target = TARGET.Blank, type = HTML_TYPE.Button, appearance = APPEARANCE.Primary, fullWidth = false, tabIndex } = _a, rest = __rest(_a, ["className", "size", "target", "type", "appearance", "fullWidth", "tabIndex"]);
    return (_jsx(ButtonPrivate, Object.assign({}, extractSupportProps(rest), extractCommonButtonProps(rest), { className: cn(styles.button, className), iconClassName: styles.icon, labelClassName: styles.label, size: size, fullWidth: fullWidth, target: target, type: type, appearance: appearance, tabIndex: tabIndex, ref: ref })));
});
